import React from 'react';
import styled, { keyframes } from 'styled-components';

type Props = {
  type?: 'product';
  customStyles?: React.CSSProperties;
};

const CardSkeleton = ({ type = 'product', customStyles }: Props) => {
  if (type === 'product') {
    return (
      <SkeletonContainer customStyles={customStyles}>
        <ImagePlaceholder />
        <RowGroup className="tw-mb-8">
          <Row width="60px" height="27px" />
          <Row width="40px" height="27px" />
        </RowGroup>
        <RowGroup className="tw-flex-col tw-gap-4">
          <Row width="100%" height="14px" />
          <Row width="50%" height="14px" />
          <Row width="60%" height="14px" />
          <Row width="90%" height="14px" />
        </RowGroup>
      </SkeletonContainer>
    );
  }
  return null;
};

export default CardSkeleton;

const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const ShimmerWrapper = styled.div`
  position: relative;
  overflow: hidden;
  background: #eee;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.6),
      transparent
    );
    animation: ${shimmer} 1.5s infinite;
  }
`;

const SkeletonContainer = styled.div<any>`
  width: ${(props) => props.customStyles?.width || '100%'};
`;

const ImagePlaceholder = styled(ShimmerWrapper)`
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  margin-bottom: 25px;
`;

const Row = styled(ShimmerWrapper)<{ width: string; height?: string }>`
  width: ${(props) => props.width};
  height: ${(props) => props.height || '20px'};
  border-radius: 6px;
`;

const RowGroup = styled.div`
  display: flex;
  gap: 10px;
`;
